module.exports = __webpack_public_path__ + "img/home-banner-3-discount-gr.bbc70b15.jpg";